
export const SavedContent = (props) => {
    const {data} = props;
    const reset = () => {
        document.getElementById('topAnchor').scrollIntoView();
    }
    return (
        <dialog id="my_saved_content_modal" className="modal h-full">
            <div className="modal-box w-4/5 max-w-6xl min-w-xl p-0 ">
                <div id="topAnchor"></div>
                <div className="bg-base-100 p-4 sticky top-0 z-50" style={{zIndex:10000}}>
                    <div className="flex space-between items-center">
                        <h2 className="card-title pl-4">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
                            </svg>

                            全文内容
                        </h2>
                        <form method="dialog">
                            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"  onClick={()=>{reset()}}>✕</button>
                        </form>
                    </div>
                </div>

                <div className="overflow-auto p-8 pt-2">
                    <div>
                        <div className="text-justify">
                            {data}
                        </div>
                    </div>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={()=>{reset()}}>close</button>
            </form>

        </dialog>
    )
}